package fyi.moko.hotpl.data.service

import fyi.moko.hotpl.domain.service.AuthService

// Apple sign-in isn't surfaced on the web build; the generic two-step fallback in
// AuthService is never reached with an Apple credential here.
internal actual suspend fun linkOrSignInWithAppleNatively(
    idToken: String,
    rawNonce: String,
): Result<AuthService.AppleLinkResult>? = null
